'use strict';

module.exports = {
    SIGN: '登陆',
    SIGN_JOIN: '登录或者免费注册！',
    EMAIL_EXISTS: '电子邮箱已存在.',
    INVALID_EMAIL: '请填写一个电子邮件地址',
    INVALID_FIRST_NAME: '请填写你的名',
    INVALID_LAST_NAME: '请填写你的姓',
    INVALID_PASSWORD: '请输入6-20个字符（仅支持A-Z，a-z，0-9）',
    INVALID_REPASSWORD: '重复输入的密码不一致',
    INVALID_VALID_CODE: '请输入验证码',
    UNAVIALABLE_SERVICE: '服务暂时不可用,请稍后重试.',
    EMPTY_VALID_CODE: '验证码错误请重新输入',
    NOT_MEMBER: '不是注册会员？',
    ALREADY_MEMBER: '已是AliExpress或Alibaba注册会员？',
    EMAIL: '电子邮件',
    CONTACT_NAME: '姓名：',
    FIRST_NAME: '名',
    LAST_NAME: '姓',
    PASSWORD: '密码',
    REPASSWORD: '重复密码：',
    EMPTY_CODE: '请输入验证码：',
    REFRESH: '刷新验证码',
    AE_MEMBER_SHIP: 'AliExpress 免费会员用户协议',
    CREATE_MY_ACCOUNT: '注册成为会员',
    NAME: '姓名',
    VERIFICATION: '验证码',
    AGREE_MENT: '通过创建帐户，您同意',
    AND: '和',
    PRIVACY_POLICY: '隐私协议',
    SLIDE_SUBMIT: '右滑验证',
    SLIDE_SUBMIT_TIPS: '成功',
    LOADING: '加载中…',
    SLIDE_SUBMIT_ERROR_TIPS: '右滑验证',
    SHOP_NOW: '立即抢购',
    SIGN_IN: '登录',
    REGISTER_SMS: 'Register with SMS',
    REGISTER_EMAIL: 'Register with Email',
    PHONE_NUMBER: 'Phone number',
    VALID_NUMBER: 'Please input a valid phone number.',
    SEND_SMS_CODE: 'Send SMS code',
    SMS_POLICY: 'We will send a verification code via SMS to the phone number you entered. Make sure both the country code and phone number are correct.',
    SEND_TO: 'We have sent the code to',
    VERIFICATION_RECEIVED: 'Enter the verification code you received or',
    EDIT_NUMBER: 'edit the number.',
    RESEND_CODE: 'Resend code',
    LAST_STEP: 'Last Step',
    SET_SIGN_IN_PASSWORD: 'Please set a Sign In password to make your account more secure.',
    INVALID_PHONE_PASSWORD: '6-20 characters (letters and numbers only)',
    NOT_CORRECT_CODE: 'The code is not correct, please try again.',
    SAVE_PASSWORD: 'Save password',
    NO_RECEIVED_CODE: "If you still haven't received the code, try to",
    VIA_EMAIL: 'Register via Email'
};